export { default } from './AuthorCard';
